export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SSO_SUCCESS = 'SSO_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const OVERWRITE_USER = 'OVERWRITE_USER';
export const AUTHORIZED_ERROR = 'AUTHORIZED_ERROR';
export const UNEXPECTED_ERROR = 'UNEXPECTED_ERROR';

export const PROGRESS_START = 'PROGRESS_START';
export const PROGRESS_END = 'PROGRESS_END';
export const PROGRESS_FAILURE = 'PROGRESS_FAILD';

export const DEAL_ERROR = 'DEAL_ERROR';
export const DEAL_UPDATE = 'DEAL_UPDATE';
export const DEAL_NOTICE = 'DEAL_NOTICE';

export const AUTHORITIES_START = 'AUTHORITIES_START';
export const AUTHORITIES_SUCCESS = 'AUTHORITIES_SUCCESS';
export const AUTHORITIES_FAILURE = 'AUTHORITIES_FAILURE';

export const CLEAR_AUTH_DATA = 'CLEAR_AUTH_DATA';
export const OVERWRITE_AUTH_DATA = 'OVERWRITE_AUTH_DATA';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const SOFT_REGISTER_RESET = 'SOFT_REGISTER_RESET';
export const SOFT_REGISTER_START = 'SOFT_REGISTER_START';
export const SOFT_REGISTER_SUCCESS = 'SOFT_REGISTER_SUCCESS';
export const SOFT_REGISTER_FAILURE = 'SOFT_REGISTER_FAILURE';

export const BEFORE_PASSWORD_CHANGE = 'BEFORE_PASSWORD_CHANGE';

export const SEND_MAIL_START = 'SEND_MAIL_START';
export const SEND_MAIL_SUCCESS = 'SEND_MAIL_SUCCESS';
export const SEND_MAIL_FAILURE = 'SEND_MAIL_FAILURE';

export const UPDATE_FORGOTTEN_PASSWORD_START = 'UPDATE_FORGOTTEN_PASSWORD_START';
export const UPDATE_FORGOTTEN_PASSWORD_SUCCESS = 'UPDATE_FORGOTTEN_PASSWORD_SUCCESS';
export const UPDATE_FORGOTTEN_PASSWORD_FAILURE = 'UPDATE_FORGOTTEN_PASSWORD_FAILURE';

export const AFTER_LOGIN_CLEAR = 'AFTER_LOGIN_CLEAR';
